import * as fromDeputy from './deputy.reducer';
import * as fromAdministratorMode from './administrator-mode.reducer';
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';


export interface CoreState {
    deputy: fromDeputy.State,
    administratorMode: fromAdministratorMode.State
}


export const coreReducers: ActionReducerMap<CoreState, any> = {
    deputy: fromDeputy.reducer,
    administratorMode: fromAdministratorMode.reducer
};

export const core = createFeatureSelector<CoreState>('core');